import MarkdownIt from 'markdown-it';

/**
 * Link and image targets that never become an href or src. markdown-it lets `data:image/*`
 * through by default; remarkable, which this replaced, refused every `data:` URL, and so do we.
 */
const BLOCKED_PROTOCOL = /^(vbscript|javascript|file|data):/;

// The default preset leaves `html` off, so raw HTML in the source is escaped, not rendered.
const markdown = new MarkdownIt();
markdown.validateLink = (url) => !BLOCKED_PROTOCOL.test(url.trim().toLowerCase());

/** HTML for markdown typed by our own staff or shipped in the translations. */
export function renderMarkdown(source: string): string {
    return markdown.render(source);
}
